import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Annonsformat och priser", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("p", null, " Digitalt annonsmaterial skall lämnas i filformaten pdf eller eps. Filerna skall ha en upplösning på minst 300 dpi och vara i färgläge CMYK. Eps-filer gjorda i Illustrator skall vara vektoriserade. ")
  ])
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12 col-sm-12 col-lg-8 col-xl-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", null, "Format och priser", -1)
const _hoisted_7 = {
  key: 0,
  class: "table table-sm table-striped table-bordered"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Beskrivning"),
    /*#__PURE__*/_createElementVNode("th", null, "Storlek"),
    /*#__PURE__*/_createElementVNode("th", null, "Pris")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("p", null, " Med utfall menas att annonsen täcker hela sidan plus att man lägger till 3 mm utanför sidan. "),
    /*#__PURE__*/_createElementVNode("p", null, " Priserna ovan förutsätter tryckfärdiga original gjorda enligt nedan. Bearbetning av ej färdiga annonser debiteras med 600:-/tim. (exkl. moms). Digitalt annonsmaterial skall lämnas i filformaten pdf eller eps. Filerna skall ha en upplösning på minst 300 dpi och vara i färgläge CMYK. Eps-filer gjorda i Illustrator skall vara vektoriserade. "),
    /*#__PURE__*/_createElementVNode("p", null, " Bokning av annonsering i 4 efterföljande utgåvor ger 20% rabatt på annonspriset. "),
    /*#__PURE__*/_createElementVNode("p", null, " Inbladade bilagor erbjuds med efterfrågad offert. Bilaga förutsätts vara färdigtryckt och i max A4-format. "),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Om du har några frågor gällande annonser är du välkommen att kontakta "),
      /*#__PURE__*/_createElementVNode("a", { href: "mailto:np@liteolika.se?subject=Annonsering%20i%20Nationellt%20Pistolskytte" }, "redaktionen"),
      /*#__PURE__*/_createTextVNode(". ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ad_nav = _resolveComponent("ad-nav")!
  const _component_loadspinner = _resolveComponent("loadspinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ad_nav),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_loadspinner, {
          message: "Hämtar format och priser...",
          loading: _ctx.state.loading
        }, null, 8, ["loading"]),
        _createElementVNode("div", null, [
          (!_ctx.state.loading)
            ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.costs, (cost) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: cost.formatId
                    }, [
                      _createElementVNode("td", null, _toDisplayString(cost.description), 1),
                      _createElementVNode("td", null, _toDisplayString(cost.printSize), 1),
                      _createElementVNode("td", null, _toDisplayString(cost.price) + " kr", 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_9
  ]))
}